module.exports = __webpack_public_path__ + "d8d3040ea71809e67e28d13b81963687.svg";